import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ThemeProvider } from "@mui/material";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Subscription } from "rxjs";
import { Chanels } from "../chanels";
import { EntityService } from "../entity/entity.service";
import { theme } from "../react-theme";
import { SignalsService } from "../signals/signals.service";
import { Guid } from "../system/guid";
import { ServiceBusService } from "../system/service-bus.service";
import "../react-components/i18n";
import TempChartPage from "./components/TempChartPage";
import moment from "moment";

const containerElementName = "myReactComponentContainer";

@Component({
  selector: "app-temp-chart-react-component",
  template: `<span #${containerElementName}></span>`,
  encapsulation: ViewEncapsulation.None,
})
export class TempChartComponent implements OnChanges, OnDestroy, AfterViewInit {
  @ViewChild(containerElementName, { static: true }) containerRef: ElementRef;

  siteId: Guid;

  @Input()
  public entityId: string;
  @Input()
  public refDate: string = moment().format();
  @Input()
  public deviationValue: number;

  public isLoadingEntities = true;

  private userSubscription: Subscription;

  private user: any;

  constructor(
    private bus: ServiceBusService,
    private entityService: EntityService,
    private signalsService: SignalsService,
  ) { }

  ngOnInit() {
    this.userSubscription = this.bus
      .chanelObservable(Chanels.USER_CHANEL)
      .subscribe((user) => {
        this.user = user;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
  }

  private render() {
    console.log(this.entityId)
    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <TempChartContext.Provider
          value={{
            user: this.user,
            entityService: this.entityService,
            signalsService: this.signalsService,
          }}
        >
          {this.entityId && <TempChartPage
            entityId={this.entityId}
            refDate={this.refDate}
            deviationValue={this.deviationValue}
          />}
        </TempChartContext.Provider>
      </ThemeProvider>,
      this.containerRef.nativeElement
    );
  }
}

type ITempChartContext = {
  user: any;
  entityService: EntityService;
  signalsService: SignalsService;
};

export const TempChartContext = React.createContext<ITempChartContext>(undefined);
